import React, { Component } from 'react';
import { Table, Button } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Sider from '../PlanSider';

class InvStart extends Component {
    state = {
        data: [],
        loading: false,
    }

    componentDidMount(){
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.queryInvestigationSiteStatistic,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    data: res.data,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { data = [] } = this.state;
        const isFixed = data && (data.length > 9);
        const columns = [{
            title: '阶段',
            dataIndex: 'stage',
            key: 'stage',
            fixed: isFixed && 'left',
            width: 100,
            render: (text, record) => {
                const obj = {
                    children: text,
                    props: { rowSpan: record.rowSpan },
                };
                return obj;
            }
        }, {
            title: '类型',
            dataIndex: 'type',
            key: 'type',
            fixed: isFixed && 'left',
            width: 100,
        }];
        if (data && data.length > 0) {
            data.forEach(item => {
                columns.push({
                    title: item.title,
                    dataIndex: item.title,
                    key: item.title,
                    width: 85,
                })
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource= [];
        if (data && data.length > 0) {
            const child = data[0];
            if (child.investigationStartList && child.investigationStartList.length > 0) {
                child.investigationStartList.forEach((item, index) => {
                    const monthParams = {
                        stage: item.typeName,
                        type: '月度计划/实际',
                        rowSpan: 2,
                    };
                    const totalParams = {
                        stage: null,
                        type: '累计计划/实际',
                        rowSpan: 0,
                    };
                    data.forEach(i => {
                        const list = i.investigationStartList;
                        const monthPlan = list[index].monthPlan;
                        const monthActual = list[index].monthActual;
                        const totalPlan = list[index].cumulativePlan;
                        const totalActual = list[index].cumulativeActual;

                        let monthColor, totalColor;
                        if (monthActual > monthPlan) {
                            monthColor = 'blue';
                        } else if (monthActual < monthPlan) {
                            monthColor = 'red';
                        }
                        monthParams[i.title] = <span>{monthPlan}/<span style={{ color: monthColor,fontWeight:600 }}>{monthActual}</span></span>;

                        if (totalActual > totalPlan) {
                            totalColor = 'blue';
                        } else if (totalActual < totalPlan) {
                            totalColor = 'red';
                        }
                        totalParams[i.title] = <span>{totalPlan}/<span style={{ color: totalColor,fontWeight:600 }}>{totalActual}</span></span>;
                    });
                    dataSource.push(monthParams);
                    dataSource.push(totalParams);
                });
            }
        }
        return dataSource;
    }

    export = () => {
        let url = API_URL.plan.exportInvestigationSiteStatistic;
        ExportUtil.export(null, null, url);
    }

    render() {
        const { loading } = this.state;
        const columns = this.getColumns();
        //const scrollX = columns.length > 10 ?  (columns.length * 85 + 30) : 955;
        const scrollX = columns.length > 10 ?  (columns.length * 85 + 30) : 880;
        return (
            <div className="content no_td_position">
                <Sider />
                <div className="main">
                    <div className="breadcrumb-bar tac">
                        <h2 className="title">项目启动计划</h2>
                    </div>
                    <div className="filter-bar bar2">
                        <div className="btn">
                            <Button type="primary" onClick={this.export}>导出</Button>
                        </div>
                    </div>
                    <Table
                        columns={columns}
                        dataSource={this.getDataSource()}
                        loading={loading}
                        pagination={false}
                        scroll={{ x: scrollX }}
                    />
                </div>
            </div>
        );
    }
}

export default InvStart;


// WEBPACK FOOTER //
// ./src/components/plan/invStart/index.js